import {
  PimDataObj,
  PimDataObjClass
} from "scrivito/Objs/PimData/PimDataObjClass"

interface UseProductInformationImportArgs {
  productType: string | null | undefined
  parentProductType?: string | null | undefined
}

export function getProductInformationImport({
  productType,
  parentProductType
}: UseProductInformationImportArgs): PimDataObj | null {
  if (!productType) {
    return null
  }
  let objSearch = PimDataObjClass.where("productType", "equals", productType)
  if (parentProductType) {
    objSearch = objSearch.and("parentProductType", "equals", parentProductType)
  }
  return objSearch.first() || null
}
